import { generateUUID } from '@Sage/ssm-utils';
import { CLEAR_TOAST, publish, SHOW_TOAST } from '../../../../utils/eventBuser';

const showToast = (props) => {
    if (!props) return;
    const id = generateUUID();
    publish(SHOW_TOAST, { ...props, id });
    return id;
};

const clearToast = (id) => {
    publish(CLEAR_TOAST, { id });
};

export { showToast, clearToast };
